import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

export const CategoryContainer = styled.div<{
	minHeight?: number;
	background?: string;
	extraStyles?: string;
	isEmpty?: boolean;
}>`
	margin-bottom: 25px;
	padding-left: 8px;
	min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'unset')};

	${breakpoint.lg`
    padding-left: 20px;
  `};

	${({ background }) =>
		background &&
		`
			background: url(${background});
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center 35px;
		`}

	${({ extraStyles }) => extraStyles}

	// Visually hide content if no content
	${({ isEmpty }) =>
		isEmpty &&
		`
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0 0 0 0);
		white-space: nowrap;
		border: 0;
	`}
`;

export const WidgetCategoryContainer = styled.div`
	margin: 12px;
	margin-bottom: 24px;

	min-height: 104px;

	&:empty {
		min-height: 0;
		margin: 0;
	}

	${breakpoint.lg`
		min-height: 162px;
  `};
`;

export const CategoryInfo = styled.div`
	display: grid;
	width: calc(100vw - 25px);
	grid-template-columns: auto auto;
	justify-content: space-between;
	align-items: end;
	padding: 0 12px 0 4px;
	margin-bottom: 10px;

	${breakpoint.lg`
    padding-right: 25px;
		justify-content: start;
  `};
`;

export const CategoryTitle = styled.h4`
	font: var(--h4-bold);
	color: rgba(var(--category-title-color), 1);
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin-right: 12px;
	cursor: pointer;
`;

export const CategoryLink = styled.button`
	height: 100%;
	font: var(--caption-bold);
	color: rgba(var(--category-link-color), 1);
	cursor: pointer;
	outline: none;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 3px;
	padding-top: 1px;

	.icon--sprite {
		fill: currentcolor;
	}
`;
